import styled from 'styled-components'

export const Step2RegisterInfoWrapper = styled.div`
  padding-bottom: 16px;
`
